<div class="duna-ics-online-container">
  @if (!userUuid) {
  <div class="error">
    <p>
      Ugyldig adresse – ingen bruger-UUID i URL. Gå til denne side via dit
      personlige link.
    </p>
  </div>
  } @if (userUuid && loading) {
  <div class="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Henter kalender...</p>
  </div>
  } @if (userUuid && error && !loading) {
  <div class="error">
    <p>{{ error }}</p>
  </div>
  } @if (userUuid && icsContent && !loading) {
  <div class="content">
    <h1>Din online kalender</h1>
    <p class="intro">
      Brug linket nedenfor til at abonnere på kalenderen i Outlook, Google
      Kalender eller din kalenderapp. Kalenderen opdateres automatisk, når du
      tilmelder eller afmelder dig events.
    </p>
    <div class="actions">
      <button mat-flat-button color="primary" (click)="downloadIcs()">
        Download .ics
      </button>
      <div class="page-link-row">
        <input
          type="text"
          class="url-input"
          [value]="calendarUrl"
          readonly
          aria-label="Kalender-URL"
        />
        <button mat-flat-button (click)="copyPageLink()">Kopier link</button>
      </div>
    </div>
    <p class="privacy">
      Del ikke linket med andre; det giver adgang til dine tilmeldte events.
    </p>
  </div>
  }
</div>
